/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import ArticleListItem from 'flarum/orell-articles/components/ArticleListItem';
import Link from 'flarum/common/components/Link';
import type Mithril from 'mithril';
import type Article from 'flarum/orell-articles/models/Article';

export interface RatingsBestArticleItemAttrs extends ComponentAttrs {
	article: Article;
	/** The article's 1-based rank within the leaderboard. */
	position: number;
}

export default class RatingsBestArticleItem extends Component<RatingsBestArticleItemAttrs> {
	oninit(vnode: Mithril.Vnode<RatingsBestArticleItemAttrs, this>) {
		super.oninit(vnode);
	}

	view() {
		const { article, position } = this.attrs;
		return (
			<div className="RatingsBestArticleItem">
				<Link href={app.route.of_article(article)}>
					<span className="ActivityLeaderItem-position">{position.toString().padStart(2, '0')}</span>
					<ArticleListItem article={article} size="medium" />
				</Link>
			</div>
		);
	}
}
